import { BaseModel } from '@shared/base.model';
import { WIZARD_INTEGRATION_STEP } from './connections-wizard-integration-step.enum';

/**
 * Settings for the connections onboarding wizard, carried under the `CONNECTIONS_WIZARD` program rule.
 *
 * The platform default lives in this constructor. `GET .../rules/CONNECTIONS_WIZARD` returns `null` for
 * every program that has never saved the wizard config — which is all of them at release — so the
 * defaulting path here is the normal one, not an edge case. Without it the option cards would render
 * with nothing selected on every program in the system.
 *
 * Uses `??` rather than the `&&`/`||` idiom the sibling rule models use: `||` would also replace a
 * future falsy-but-valid value, and there is no reason to copy that.
 */
export class ConnectionsWizardSettings extends BaseModel<ConnectionsWizardSettings> {
  integrationStep: WIZARD_INTEGRATION_STEP;

  constructor(settings?: any) {
    super();
    this.integrationStep = settings?.integrationStep ?? WIZARD_INTEGRATION_STEP.REQUIRED;
  }
}
